/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import { useTranslation } from 'react-i18next';
import { Icon } from './icon/Icon';

const StyledContainer = styled.div`
  position: relative;
  width: ${({ width }) => width || 'auto'};
  text-align: left;
  height: inherit;
  input {
    padding: 32px 27px 13px 12px;
  }

  input + label {
    display: block;
    pointer-events: none;
    font-family: 'Hind';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
  }
  > svg {
    transform: translateY(-31px);
  }
`;

const StyledInputWrapper = styled.input.attrs({
  type: 'text'
})`
  width: inherit;
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: inline-block;
  border: 1px solid ${select('midDarkGray')};
  box-sizing: border-box;
  border-radius: 8px;
  height: 48px;
  ${({ active }) =>
    active &&
    css`
      border: 1px solid ${getColor('primary')};
    `}
  ${({ invalidDate }) =>
    invalidDate &&
    css`
      border: 1px solid ${select('negative')};
    `}
`;

const StyledLabel = styled.label`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 26px;
  position: absolute;
  top: 3px;
  left: 13px;
  color: ${({ active }) => active && getColor('primary')};
  ${({ invalidDate }) =>
    invalidDate &&
    css`
      color: ${select('negative')};
    `}
`;

const InputError = styled.div`
  ${({ invalidDate }) =>
    invalidDate &&
    css`
      font-family: 'Hind';
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 26px;
      position: absolute;
      top: 48px;
      left: 13px;
      color: ${select('negative')};
    `}
`;

const InputText = React.forwardRef(
  (
    { placeHolder = '', iconName = '', width = '170px', label = '', invalidDate = false, value, active, onChange },
    ref
  ) => {
    const { t } = useTranslation();
    return (
      <StyledContainer width={width}>
        <StyledInputWrapper
          readOnly
          ref={ref}
          active={active}
          invalidDate={invalidDate}
          placeholder={placeHolder}
          value={value}
          onChange={onChange}
        />
        {label && (
          <StyledLabel active={active} invalidDate={invalidDate}>
            {t(`panel.estadisticas.dropdown.customPeriod.${label}`)}
          </StyledLabel>
        )}
        {iconName && <Icon name={iconName} margin='0 13px' float='right' />}
        {invalidDate && (
          <InputError invalidDate={invalidDate}>{t('panel.estadisticas.dropdown.customPeriod.invalidDate')}</InputError>
        )}
      </StyledContainer>
    );
  }
);

export { InputText };
